import type { List, ListItem } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { FromPMHandlers } from '../types';

export function convertList(
	node: PMNode,
	ordered: boolean,
	handlers: FromPMHandlers,
): {
	children: ListItem[];
	ordered: boolean;
	spread: false;
	start: number | undefined;
	type: 'list';
} {
	const children: ListItem[] = [];
	node.forEach((child) => {
		const handler = handlers[child.type.name];
		if (handler) {
			const result = handler(child);
			if (!result || Array.isArray(result)) {
				return;
			}
			if (result.type === 'listItem') {
				children.push(result as ListItem);
			} else if (result.type === 'list' && children.length > 0) {
				const previous = children[children.length - 1];
				previous.children.push(result as List);
			}
		}
	});

	const start: number | undefined = ordered
		? ((node.attrs.order ?? node.attrs.start ?? 1) as number)
		: undefined;

	return {
		type: 'list' as const,
		ordered,
		start,
		spread: false,
		children,
	};
}
